module.exports = __webpack_public_path__ + "static/media/₹-bag.98662d59.svg";